export default __webpack_public_path__ + "static/media/sentiment-neutral.0e8bf60c.svg";